import { useEffect } from "react";

export const SITE_URL = "https://rudrima.com";
const DEFAULT_TITLE = "Rudrima – Pure A2 Cow Ghee & Natural Forest Honey";
const DEFAULT_DESC =
  "Rudrima sells Pure A2 Cow Ghee (500g, traditional Bilona made) and Pure Forest Honey (500g, 100% natural & raw). Hygienically packed, secure Shopify checkout, delivered across India.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  let el = document.getElementById("seo-jsonld");
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "seo-jsonld";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function applySeo({ title, description, path = "/", image, type = "website", jsonLd }) {
  const url = `${SITE_URL}${path}`;
  document.title = title;
  upsertMeta("name", "description", description);
  upsertLink("canonical", url);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "og:site_name", "Rudrima");
  upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  if (image) {
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:image", image);
  }
  setJsonLd(jsonLd);
}

export function useSeo(seo) {
  const key = JSON.stringify(seo);
  useEffect(() => {
    applySeo(JSON.parse(key));
    return () => applySeo({ title: DEFAULT_TITLE, description: DEFAULT_DESC, path: "/" });
  }, [key]);
}
